import React from 'react'
import { Link } from 'react-router-dom'
function ProductsDetailsSection5() {
  return (
    <div>
      <>
      <div className="container-fluid px-5 bgg-col backSection14 py-5 backcolor1">
        {/* Heading Row */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h3 className="mb-0">Hijama & Healthcare books</h3>
          <p className="text-dark mb-0 ">
          {/* <span className="d-flex justify-content-between align-items-center gap-1 ">View All<i className="bi bi-chevron-right viewAll"></i></span> */}
        </p>
          
        </div>

        {/* Product Cards */}
        

        <div className="row g-4">
        <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
            <div className="position-relative d-inline-block">
            <img src="/Images/Ayurveda_Book.webp" className="card-img-top" alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1 fw-bold">Practical Prescriber|  </h6>
              <small className="mb-0 ">The Ayurveda Book</small>
              <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹110</p>
              <small className="text-decoration-line-through text-muted ">$7.19</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
              <Link to='/Cart' className="text-decoration-none">
              <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                  Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                </div>
                </Link>
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
            <div className="position-relative d-inline-block">
            <img src="/Images/Motape_Se_Breakup.webp" className="card-img-top" alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1 fw-bold">Motape Se Break Up |  </h6>
              <small className="mb-0">Bestseller Book On Weight Lose</small>
              <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹110</p>
              <small className="text-decoration-line-through text-muted ">$7.19</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
              <Link to='/Cart' className="text-decoration-none">
              <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                  Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                </div>
                </Link>
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
            <div className="position-relative d-inline-block">
            <img src="/Images/Bimariya_Harenge.webp" className="card-img-top" alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1 fw-bold">Bimariyan Harenge |</h6>
              <small className="mb-0">Best Health Care Book</small>
             <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹110</p>
              <small className="text-decoration-line-through text-muted ">$7.19</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
              <Link to='/Cart' className="text-decoration-none">
              <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                  Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                </div>
                </Link>
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
          <div className="card custom-card">
           
            <div className="position-relative d-inline-block">
            <img src="/Images/Bimar_Hona_Bhul_Jaye.webp" className="card-img-top" alt="Avatar" />
            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">25% offer</span>
            </div>
            <div className="card-body text-start">
              <h6 className="card-title mb-1 fw-bold">Bimar Hona Bhul Jaye |</h6>
              <small className="mb-0"> Best SelfCare Book | Hindi Book</small>
              <div className="d-flex align-items-center justify-content-start gap-2 ">
              <p className="card-text fw-bold text-success mb-0">₹110</p>
              <small className="text-decoration-line-through text-muted ">$7.19</small>
              </div>
             
              <div className="text-warning mb-1">
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-fill"></i>
                <i className="bi bi-star-half"></i>
              </div>
              <Link to='/Cart' className="text-decoration-none">
              <div className="bg-col text-white fw-semibold py-2 mt-auto rounded d-flex justify-content-center align-items-center" role="button">
                  Add to Cart <span className="ms-2"><i className="bi bi-bag"></i></span>
                </div>
                </Link>
            </div>
          </div>
        </div>
      </div>
      </div>
      
    </>
    </div>
  )
}

export default ProductsDetailsSection5
